// src/App.js
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './components/Home';
import CreateList from './components/CreateList';
import ListView from './components/ListView';
import ComparisonView from './components/ComparisonView';
import PrivacyPolicy from './components/PrivacyPolicy';
import AdminPanel from './components/AdminPanel';
import ImageUploadRules from './components/imageRules';
import { generateFingerprint } from './utils/fingerprint';

import './App.css';

function App() {
  const [creatorId, setCreatorId] = useState(null);

  useEffect(() => {
    // Get or create creator ID
    let id = localStorage.getItem('creatorId');
    if (!id) {
      id = generateFingerprint();
      localStorage.setItem('creatorId', id);
    }
    setCreatorId(id);
  }, []);

  if (!creatorId) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/create" element={<CreateList creatorId={creatorId} />} />
          <Route path="/list/:listId" element={<ListView creatorId={creatorId} />} />
          <Route path="/compare/:listId" element={<ComparisonView />} />
          <Route path="/admin/:listId" element={<AdminPanel creatorId={creatorId} />} />
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/imageRules" element={<ImageUploadRules />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;